'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileFooter = renderWithRef('StandardTileFooter', null, (e, t)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-standard-tile-footer'
        ],
        props: e,
        children: e.children
    }));

export { StandardTileFooter };
